import React from 'react';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer3 from '../components/Footer3';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ProjectFilter from '../components/ProjectFilter';

function Projects() {
    return (
        <>
            <Header1 />
            <PageBanner bannerBg={bannerBg} heading="Case Study" currentPage="Project" />
            <ProjectFilter />
            <Footer3 />
        </>
    );
}

export default Projects;
